const ServicioPermisos = function() {

    const permisos = {};

    this.Permisos = permisos;

    this.ObtenerPermisos = p => {
        if (Array.isArray(p)) {
            p.forEach(permiso => {
                if (!permisos.hasOwnProperty(permiso.TipoPermiso)) {
                    permisos[permiso.TipoPermiso] = {
                            ConEscritura: permiso.ConEscritura                        
                    };
                }
            });
        }
    };

    this.ReiniciarPermisos = () => {
        for (let prop in permisos) {
            if (permisos.hasOwnProperty(prop)) {
                delete permisos[prop];
            }       
        }
    };

};

export default ServicioPermisos;
